/** 
 * Cookie handling
 */
const setCookie = (cname, cvalue, exdays) => {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

const getCookie = (cname) => {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++)
  {
    var c = ca[i];
    while (c.charAt(0) == ' ')
    {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0)
    {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

/**
 * Url params
 */

const removeParam = (key, sourceURL) => {
  var rtn = sourceURL.split("?")[0],
    param,
    params_arr = [],
    queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
  if (queryString !== "")
  {
    params_arr = queryString.split("&");
    for (var i = params_arr.length - 1; i >= 0; i -= 1)
    {
      param = params_arr[i].split("=")[0];
      if (param === key)
      {
        params_arr.splice(i, 1);
      }
    }
    if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
  }
  return rtn;
}

const checkUrlRedirect = () => {
  const urlParams = new URLSearchParams(window.location.href);
  const redirect = urlParams.get('rdrct');

  if (redirect)
  {
    history.replaceState(null, null, removeParam('rdrct', window.location.href));
    setCookie("country_redirected", true, 64)

    return false
  }

  return true
} 
 

const geoPopup = document.querySelector('.js-geo-popup')

if (geoPopup && languageObj)
{


  const geoPopupOverlay = geoPopup.querySelector('.geo-popup__overlay')
  const geoPopupButtons = geoPopup.querySelector('[data-buttons]')

  /**
   * Popup Actions
   */
  const open = () => {
    geoPopup.classList.add('open');
  };
  const close = () => {
    geoPopup.classList.remove('open');
  };
  const triggerClose = () => {
    close();
    console.warn('An error has occurred');
  }

  /**
   * Popup Data
   */
  const getLocation = () => {
    fetch('https://api.ipgeolocation.io/ipgeo?apiKey=' + ipgk)
      .then((r) => r.json())
      .then((data) => {
        initGeoPopup(data);
      })
      .catch((err) => { triggerClose(); });
  };

  /** 
   * Popup Render Html
   */

  const redirectUrl = () => {

    const currentUrl = window.location.href;
    const pathname = new URL(currentUrl).pathname;

    const redirectTag = 'rdrct=true';

    if (pathname)
    {
      let redirectUrl = pathname;

      if (redirectUrl.includes('?'))
      {
        redirectUrl = pathname + '&' + redirectTag
      }
      else
      {
        redirectUrl = pathname + '?' + redirectTag
      }

      return redirectUrl
    }
    else
    {
      return '?' + redirectTag
    }
  }

  const createButton = (language, userCountryCode) => {

    const name = language.name,
      countryCode = language.countryCode.toUpperCase(),
      src = language.src,
      url = language.url,
      currentShopLanguange = language.currentLanguange,
      matchesCurrentUserCountryCode = userMatchesCountryCodeArr(countryCode, userCountryCode);

    /**
     * 
     */

    if (currentShopLanguange == true)
    {
      return `
          <div class="geo-popup__button">
            <p class="geo-popup__button__inner">${ name }</p>
          </div>
      `;
      //     return `
      //     <div class="geo-popup__button">
      //       <p class="geo-popup__button__inner">${ name }</p>
      //       <img src="${ src }" class="geo-popup__button__img" />
      //     </div>
      // `;
    }
    else
    {
      const pUrl = redirectUrl();
      return `
          <a href="${ url + pUrl }" class="geo-popup__button ${ matchesCurrentUserCountryCode ? 'highlight' : null }">
            <p class="geo-popup__button__inner">${ name }</p>
          </a>
      `;
      // return `
      //     <a href="${ url + pUrl }" class="geo-popup__button ${ matchesCurrentUserCountryCode ? 'highlight' : null }">
      //       <p class="geo-popup__button__inner">${ name }</p>
      //       <img src="${ src }" class="geo-popup__button__img" />
      //     </a>
      // `;
    }
  }

  const userMatchesCountryCodeArr = (countryCodes, userCountryCode) => {
    let matches = false;
    const countryCodeArr = countryCodes.split(',');
    countryCodeArr.forEach(countryCode => {
      if (matches) return
      if (countryCode == userCountryCode)
      {
        matches = true
      }
    })

    return matches
  }

  const checkUserMatchesCurrentStoreCountry = (languageObj, userCountryCode) => {
    const currentStoreCountryCode = languageObj.filter(language => language.currentLanguange === true);


    if (currentStoreCountryCode.length > 0)
    {
      return userMatchesCountryCodeArr(currentStoreCountryCode[0].countryCode, userCountryCode);
    }
    return false
  }

  const buttonClickHandler = (button) => {
    button.addEventListener('click', (e) => {
      if (e.currentTarget.tagName == 'A') return
      setCookie("country_redirected", true, 64);
      close();
    })
  }



  const initGeoPopup = (data) => {

    if (!checkUserMatchesCurrentStoreCountry(languageObj, data.country_code2))
    {
      geoPopup.classList.remove('no-animate');
      geoPopupOverlay.addEventListener('click', () => {
        close();
      })
      languageObj.forEach(language => {
        geoPopupButtons.insertAdjacentHTML('beforeend', createButton(language, data.country_code2))
      })

      geoPopupButtons.querySelectorAll('.geo-popup__button')?.forEach(button => {
        buttonClickHandler(button);
      })

      open();
    }
  }


  let cookieInit = false;

  // Check if url contains rdrct and then set cookie
  // window.addEventListener('CookiebotOnAccept', function(e) {
    if (!cookieInit)
    {
      cookieInit = true

      if (!getCookie('country_redirected') && Cookiebot.consent.necessary)
      {
        if (checkUrlRedirect())
        {
          getLocation();
        }
      }
    }

  // }, false);

  // window.addEventListener('CookiebotOnLoad', function(e) {
    if (!cookieInit)
    {
      cookieInit = true

      if (!getCookie('country_redirected') && Cookiebot.consent.necessary)
      {
        if (checkUrlRedirect())
        {
          getLocation();
        }
      }
    }

  // }, false);
}
else
{
  if (!geoPopup && languages.length > 0)
  {
    console.warn('Cant find .js-geo-popup');
  }
  if (!languages || !languages.length > 0)
  {
    console.warn('No Languages added');
  }
}
